// "Replay from the C64": a disk image (D64) with the REPLAY program (replay.asm, built to replay.prg) and a
// DATA.SEQ that holds a print job in the format replay.asm reads. The page sends the job back through the C64's
// own serial port to a real printer, or to this device.
import { buildD64 } from './d64.js';

export const REPLAY_CHUNK = 128; // replay.asm reads and prints the file in chunks of this size
const ESC = 0xfe;

// The stream of DATA.SEQ for the events of a job (jobs.js): printer data between LISTEN and UNLISTEN of a data
// channel; open/close frames carry nothing for a printer. $fe $01 sa starts a transfer, $fe $02 ends it, a data
// byte $fe is written $fe $00 (the same escape the wire format of the device uses).
export function replayStream(events) {
  const out = [];
  let open = false;
  const end = () => {
    if (open) out.push(ESC, 2);
    open = false;
  };
  for (const ev of events) {
    if (ev.t === 'listen') {
      end();
      if ((ev.sa & 0xf0) === 0x60) {
        out.push(ESC, 1, ev.sa & 0x0f);
        open = true;
      }
    } else if (ev.t === 'unlisten') {
      end();
    } else if (ev.t === 'data' && open) {
      for (const b of ev.bytes) {
        if (b === ESC) out.push(ESC, 0);
        else out.push(b);
      }
    }
  }
  end();
  return Uint8Array.from(out);
}

// DATA.SEQ: the number of chunks (16 bit, little endian) and the stream. null if there is nothing to print.
export function buildReplaySeq(events) {
  const stream = replayStream(events);
  if (!events.some((e) => e.t === 'data' && e.bytes.length > 0) || stream.length === 0) return null;
  const chunks = Math.max(1, Math.ceil(stream.length / REPLAY_CHUNK));
  if (chunks > 0xffff) throw new Error('this job is too big for a replay disk');
  const seq = new Uint8Array(2 + stream.length);
  seq[0] = chunks & 0xff;
  seq[1] = chunks >> 8;
  seq.set(stream, 2);
  return seq;
}

// The disk image, or null if the job has nothing to print. prg: the bytes of replay.prg.
export function buildReplayDisk(events, prg) {
  const seq = buildReplaySeq(events);
  if (!seq) return null;
  return buildD64({
    diskName: 'PRINTY REPLAY',
    diskId: 'PR',
    files: [
      { name: 'REPLAY', type: 'PRG', data: prg },
      { name: 'DATA.SEQ', type: 'SEQ', data: seq },
    ],
  });
}
